import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-pill border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider transition-colors',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-greeniq-500/15 text-greeniq-300 ring-1 ring-inset ring-greeniq-500/30',
        secondary:
          'border-border bg-bg-elevated text-fg-secondary',
        outline:
          'border-border text-fg-secondary',
        success:
          'border-transparent bg-success-muted text-[color:var(--color-success)]',
        warning:
          'border-transparent bg-warning-muted text-[color:var(--color-warning)]',
        destructive:
          'border-transparent bg-error-muted text-[color:var(--color-error)]',
        info:
          'border-transparent bg-info-muted text-[color:var(--color-info)]',
        muted:
          'border-border bg-bg-card text-fg-muted',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
